const featureEN = {
    "view": {
        "table": {
            "title": "Feature Requests",
            "column": {
                "release_name": "Name",
                "release_artist_name": "Release Artist Name",
                "release_date": "Release Date",
                "exclusive_date": "Exclusive Date",
            },
            "button": {
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
        },
        "message": {
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information.",
        }
    },
    "add": {
        "title": "Marketing Facts",
        "form": {
            "label": {
                "release": "Release",
                "djTastemaker": "DJ / TasteMaker feedbacks:",
                "radioSupport": "Radio support",
                "marketingPR": "Marketing / Pr",
                "labelReach": "Label and artists reach:",
            },
            "help_text": {
                "release": "Select a release for which you want to submit featuring request. You can only see and select releases which are having a general release date 22 or more days in advance. If you are targeting for an exclusive release date pitch, please make sure to submit this form at least 22 days before a (first) exclusive release date.",
                "djTastemaker": "Insert 10 DJ / Radio / Magazine feedbacks in format 'Name - Feedback' (Insert each feedback in one line). Submissions containing 'downloading for' won’t be promoted or sent to online shops.",
                "radioSupport": "Is your song or a release featured at some radio stations? If so name the station and insert the corresponding link to their page where it is visible they are promoting or playing your songs.",
                "marketingPR": "(Interviews, blogs, reviews, magazine articles) - Please list all committed press & marketing activities for this release. Not mandatory but essentially important to stand out of competition.",
                "labelReach": "The combined (label and artists) amount of followers on Facebook, Instagram, SoundCloud, and YouTube. <strong>Please put each platform and number of followers in a new row</strong>."
            },
            "button": {
                "submit": "Submit",
            },
            "message": {
                "releaseRequired": "Existing release is required",
                "featureRequestAlreadyExists": "Feature request for this release was already made"
            }
        },
        "message": {
            "success": "Feature request has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
        },
        "modal": {
            "confirm": {
                "header": "New feature request",
                "body": "This feature request has to be submitted at least 21 days before the first (exclusive or general, whatever comes first) date. Unfortunately, late submissions cannot be taken into consideration. Do you want to submit your feature request?",
            }
        }
    }
};
  
  
export default featureEN;